import { render, staticRenderFns } from "./marketing-block.vue?vue&type=template&id=682b9ce3"
import script from "./marketing-block.vue?vue&type=script&lang=js"
export * from "./marketing-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports